import React from 'react';

import { BILLING_ADDONS } from 'constants/billing';

export const L10nAIWinLossAnalysis = /** @type {const} */ ({
  aiWinLossAnalysis: 'AI Win/Loss Analysis',
  dealsTimeline: 'Deals Timeline',
  noDealsFound:
    'No deals found for the applied filters, try changing the filters to see results',
  thatsAllForDeals:
    'You have reached the end of the deals for the selected date range.',
  viewComments: 'View Comments',
  generateAIAnalysis: 'Generate AI Analysis',
  clickToRefreshStatus: 'Click to refresh status',
  winlossAnalysis: 'Win/Loss Analysis',
  closedDeals: 'Closed Deals',
  closedWon: 'Closed Won',
  closedLost: 'Closed Lost',
  winRatePercent: 'Win Rate %',
  winRate: 'Win rate',
  averageWinRate: 'Average win rate',
  winlossAnalysisTooltip:
    'Win/Loss % breakdown of closed deals for selected time period',
  winRateTooltip: 'Trend for deals won for selected time period',
  winLossTrend: 'Win/Loss Trend (Last 12 months)',
  duration: 'Duration',
  dealsWon: 'Deals Won',
  dealsLost: 'Deals Lost',
  clickToViewWinLossAnalysisFor: 'Click to view win/loss analysis for',
  errors: {
    noEngagements: () =>
      'AI analysis is not generated as there is minimal or no engagement (meetings, calls and emails) on this deal.',
    noAssociatedDomain: () =>
      'AI analysis is not generated as there is no associated domain with the deal.',
    ownNoFeat: () => (
      <React.Fragment>
        AI win/loss analysis is <strong>not</strong> generated. The{' '}
        <strong>deal owner</strong> needs to have a{' '}
        <strong>{BILLING_ADDONS['ri-addon']}</strong> add-on.
        <br />
        Please contact your <strong>Customer Success Manager</strong> for
        details about the add-on purchase.
      </React.Fragment>
    )
  }
});
